/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team — AI-powered optimizer that finds the highest expected fantasy points team within your $100M budget. Runs Monte Carlo simulations across all valid driver and constructor combinations.`)
};

const es_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo Apex — Optimizador impulsado por IA que encuentra el equipo con mayor puntuación fantasy esperada dentro de tu presupuesto de $100M. Ejecuta simulaciones Monte Carlo a través de todas las combinaciones válidas de pilotos y constructores.`)
};

const de_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex-Team — KI-gestützter Optimizer, der das Team mit den höchsten erwarteten Fantasy-Punkten innerhalb deines $100M-Budgets findet. Führt Monte-Carlo-Simulationen über alle gültigen Fahrer- und Konstrukteurkombinationen durch.`)
};

const nl_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team — AI-gestuurde optimizer die het hoogst scorende fantasy-team vindt binnen je $100M budget. Draait Monte Carlo-simulaties over alle geldige coureurs- en constructeurscombinaties.`)
};

const fr_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe Apex — Optimiseur propulsé par IA qui trouve l’équipe avec les points fantasy attendus les plus élevés dans votre budget de $100M. Exécute des simulations Monte Carlo sur toutes les combinaisons valides de pilotes et constructeurs.`)
};

const it_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Apex — ottimizzatore basato su AI che trova il team con i punti fantasy attesi più alti entro il budget di $100M. Esegue simulazioni Monte Carlo su tutte le combinazioni valide di piloti e costruttori.`)
};

const pt_br2_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe Apex — Otimizador com IA que encontra a equipe de fantasy com maior pontuação esperada dentro do seu orçamento de $100M. Executa simulações Monte Carlo em todas as combinações válidas de pilotos e construtores.`)
};

const pt_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipa Apex — Otimizador com IA que encontra a equipa com maior pontuação fantasy esperada dentro do orçamento de $100M. Executa simulações Monte Carlo em todas as combinações válidas de pilotos e construtores.`)
};

const ja_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apexチーム — $100Mの予算内で最高の期待ファンタジーポイントチームを見つけるAI搭載オプティマイザー。有効なドライバーとコンストラクターの全組み合わせでモンテカルロシミュレーションを実行。`)
};

const zh_about_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex团队 — AI驱动的优化器，在$100M预算内找到最高预期梦幻积分车队。对所有有效车手和车队组合运行蒙特卡罗模拟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_apex_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_apex_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_apex_desc", locale)
	if (locale === "en") return en_about_apex_desc(inputs)
	if (locale === "es") return es_about_apex_desc(inputs)
	if (locale === "de") return de_about_apex_desc(inputs)
	if (locale === "nl") return nl_about_apex_desc(inputs)
	if (locale === "fr") return fr_about_apex_desc(inputs)
	if (locale === "it") return it_about_apex_desc(inputs)
	if (locale === "pt-BR") return pt_br2_about_apex_desc(inputs)
	if (locale === "pt") return pt_about_apex_desc(inputs)
	if (locale === "ja") return ja_about_apex_desc(inputs)
	return zh_about_apex_desc(inputs)
};